// extracted by mini-css-extract-plugin
module.exports = {"productsContainer":"TrxnHistoryTable_productsContainer_1Djrm","emptyItems":"TrxnHistoryTable_emptyItems_3VH95"};